import { TopicElementType } from 'front-end/src/graphql/private/PrivateSchemaTypes'

export const isSingleChoice = (type: TopicElementType) => {
  return type === TopicElementType.QUIZ_SINGLE
}

export const isMultiChoice = (type: TopicElementType) => {
  return type === TopicElementType.QUIZ_MULTI
}

export const isOpenChoice = (type: TopicElementType) => {
  return type === TopicElementType.QUIZ_OPEN
}

export const isFreeChoice = (type: TopicElementType) => {
  return type === TopicElementType.QUIZ_FREE
}

export const showSubmitOption = (selectedOptions, quizResponse) => {
  return selectedOptions.length > 0 && !quizResponse
}
